'use client';
import { makeIcon } from '@vkontakte/icons-sprite';
export var Icon24CircleSmall = makeIcon('Icon24CircleSmall', 'circle_small_24', '0 0 24 24', '<symbol xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" id="circle_small_24"><circle cx="12" cy="12" r="7" /></symbol>', 24, 24, false, undefined);
